import { render } from "./index.vue?vue&type=template&id=0768231c&scoped=true"
const script = {}

import "./index.css?vue&type=style&index=0&id=0768231c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0768231c"]])

export default __exports__